module.exports = "input {\n  max-width: 3rem; }\n"